exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.i(require("-!../../../../../node_modules/css-loader/index.js?{\"importLoaders\":1,\"modules\":{\"localIdentName\":\"[name]__[local]___[hash:base64:5]\"}}!../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../containers/Popovers/Popovers.css"), undefined);

// module
exports.push([module.id, "._2b9ddLHd9EqB8ExdQAKnM9 {\n}\n", ""]);

// exports
exports.locals = {
	"popover": "" + require("-!../../../../../node_modules/css-loader/index.js?{\"importLoaders\":1,\"modules\":{\"localIdentName\":\"[name]__[local]___[hash:base64:5]\"}}!../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../containers/Popovers/Popovers.css").locals["popover"] + "",
	"datePopover": "_2b9ddLHd9EqB8ExdQAKnM9 " + require("-!../../../../../node_modules/css-loader/index.js?{\"importLoaders\":1,\"modules\":{\"localIdentName\":\"[name]__[local]___[hash:base64:5]\"}}!../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../containers/Popovers/Popovers.css").locals["popover"] + ""
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/legacy/containers/Popovers/DatePopover/DatePopover.css
// module id = 3110
// module chunks = 23